export interface Coord {
  startX: number;
  startY: number;
  width: number;
  height: number;
  [key: string]: any;
}

// Anything thinner than this is a stray click in the marking tool, not an article.
const MIN_BOX = 0.005;

const clamp = (value: number) => Math.max(0, Math.min(1, value));

// Marks drawn bottom-up or right-to-left in the admin are stored with a negative
// width/height. A negative CSS percentage is invalid, so the overlay collapses to
// nothing — the article looks unmarked and cannot be clicked. Re-anchor every box
// to its top-left corner, clamp it to the page and drop the zero-size leftovers.
const normalizeCoords = (coords: any): Coord[] => {
  if (!Array.isArray(coords)) return [];

  return coords.reduce((acc: Coord[], pos: any) => {
    const startX = Number(pos?.startX);
    const startY = Number(pos?.startY);
    const width = Number(pos?.width);
    const height = Number(pos?.height);

    if (![startX, startY, width, height].every(Number.isFinite)) return acc;

    const left = clamp(Math.min(startX, startX + width));
    const top = clamp(Math.min(startY, startY + height));
    const right = clamp(Math.max(startX, startX + width));
    const bottom = clamp(Math.max(startY, startY + height));

    if (right - left < MIN_BOX || bottom - top < MIN_BOX) return acc;

    acc.push({
      ...pos,
      startX: left,
      startY: top,
      width: right - left,
      height: bottom - top,
    });
    return acc;
  }, []);
};

export default normalizeCoords;
